export const captchaV2Key = '6LebPuUUAAAAAEsnAd6E-vBCeGUKEpQUsS0CtREf';
export const captchaV3Key = '6LehPOQUAAAAABDj6JsW_QsZw_4ZgHRCq4zgzPFu';
